// Лёгкий рендер разметки в репликах: **жирный**, `код`, ссылки (кликабельные),
// заголовки, списки, переносы строк. Без сторонних библиотек и без
// dangerouslySetInnerHTML (безопасно для текста от агента).

import { Fragment, type ReactNode } from 'react'

const INLINE = /(\[[^\]]+\]\([^)]+\))|(\*\*[^*]+\*\*)|(`[^`]+`)|(https?:\/\/[^\s)]+)/g

function renderInline(text: string, keyBase: string): ReactNode[] {
  const nodes: ReactNode[] = []
  let last = 0
  let i = 0
  let m: RegExpExecArray | null
  INLINE.lastIndex = 0
  while ((m = INLINE.exec(text))) {
    if (m.index > last) nodes.push(text.slice(last, m.index))
    const tok = m[0]
    const key = `${keyBase}-${i++}`
    if (m[1]) {
      const lm = /^\[([^\]]+)\]\(([^)]+)\)$/.exec(tok)
      if (lm) {
        nodes.push(
          <a key={key} href={lm[2]} target="_blank" rel="noopener noreferrer">
            {lm[1]}
          </a>,
        )
      }
    } else if (m[2]) {
      nodes.push(<strong key={key}>{tok.slice(2, -2)}</strong>)
    } else if (m[3]) {
      nodes.push(<code key={key}>{tok.slice(1, -1)}</code>)
    } else if (m[4]) {
      nodes.push(
        <a key={key} href={tok} target="_blank" rel="noopener noreferrer">
          {tok}
        </a>,
      )
    }
    last = m.index + tok.length
  }
  if (last < text.length) nodes.push(text.slice(last))
  return nodes
}

export function RichText({ text }: { text: string }) {
  const lines = String(text).split('\n')
  return (
    <>
      {lines.map((line, idx) => {
        const heading = /^\s{0,3}(#{1,6})\s+(.*)$/.exec(line)
        const bullet = /^\s*[-*•]\s+(.*)$/.exec(line)
        let content: ReactNode
        if (heading) content = <strong>{renderInline(heading[2], `l${idx}`)}</strong>
        else if (bullet) content = <>{'• '}{renderInline(bullet[1], `l${idx}`)}</>
        else content = renderInline(line, `l${idx}`)
        return (
          <Fragment key={idx}>
            {idx > 0 && <br />}
            {content}
          </Fragment>
        )
      })}
    </>
  )
}
